import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetDrop: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2c-4 4-7 8-7 12a7 7 0 0014 0c0-4-3-8-7-12z" />
      </svg>
    </div>
  );
};

export default WidgetDrop;
